<template>
  <b-col>
    <b-card
      no-body
      class="p-2 border border-2"
    >
      <div class="flex justify-between">
        <div class="flex gap-2">
          <b-img
            class="w-[20px] h-[20px]"
            src="https://storage.googleapis.com/komerce/assets/register-icon.svg"
          />
          Closing Order
        </div>
        <FilterDropdown
          id="closingOrder"
          :options="optionsFilter"
          :value="filterClosingOrder"
          @change="handleFilterChange($event, 'closingOrder')"
          @date-change="handleDateFilterChange($event, 'closingOrder')"
        />
      </div>
      <div class="font-poppins text-[#626262] mb-2 font-semibold text-[28px] leading-[38px] tracking-[0] align-middle">
        Rp. {{ IDRWithoutLbl(animatedCard.closingOrder.revenue || 0) }} <span
          class="rounded-lg px-[4px] font-poppins font-normal text-[12px] leading-[20px] tracking-[0] align-middle"
          :class="dataCard.closingOrder.percentage.includes('-') ? 'bg-[#E31A1A] text-white' : 'bg-[#BEFCDE] text-[#34A770]'"
        >{{
          dataCard.closingOrder.percentage }}</span>
      </div>
      <div class="text-sm">
        Total Close Order: <span class="font-bold text-[#626262]">{{ animatedCard.closingOrder.total }}</span>
      </div>
    </b-card>
  </b-col>
</template>

<script>
import { IDRWithoutLbl } from '@/libs/currency'
import FilterDropdown from './FilterDropdown.vue'

export default {
  name: 'ClosingOrderCard',
  components: {
    FilterDropdown,
  },
  props: {
    animatedCard: {
      type: Object,
      required: true,
    },
    dataCard: {
      type: Object,
      required: true,
    },
    filterClosingOrder: {
      type: String,
      default: 'All Time',
    },
    optionsFilter: {
      type: Array,
      default: () => ([
        { label: 'All Time', value: 'All Time' },
        { label: 'Last 7 Days', value: 'Last 7 Days' },
        { label: 'Last 30 Days', value: 'Last 30 Days' },
        { label: 'Date Picker', value: 'Date Picker' },
      ]),
    },
  },
  data() {
    return {
      IDRWithoutLbl,
    }
  },
  methods: {
    handleFilterChange(value, type) {
      this.$emit('change', { value, type })
    },
    handleDateFilterChange(dateRange, type) {
      this.$emit('date-change', { dateRange, type })
    },
  },
}
</script>
